import WhichPolygon from 'which-polygon';

const geoJson = require('./ne_110m_admin_0_countries.json');

const query = WhichPolygon(geoJson);

/**
 * @deprecated TODO: Migrate to standardized geo-lookup service
 *
 * ISSUES:
 * 1. Uses bundled JSON file (ne_110m_admin_0_countries.json) - ~361 lines, potential security/maintenance risk
 * 2. Data could be outdated (no clear update strategy)
 * 3. Lacks error handling for edge cases (oceans, disputed territories, etc.)
 * 4. Type safety is poor (any types, no validation)
 *
 * MIGRATION PLAN:
 * - Evaluate external geo-coding services (Google Maps, Mapbox, etc.)
 * - Or use maintained npm packages with regular updates
 * - Implement proper error handling and caching
 * - Add TypeScript types for geo-coordinates and country data
 * - Consider rate limiting and fallback strategies
 */
type CountryProperties = {
  iso_n3?: string;
  name?: string;
  [key: string]: unknown;
} | null;

export default function getCountryByGeoLocation({
  latitude,
  longitude,
}: {
  latitude?: number;
  longitude?: number;
}): CountryProperties {
  if (latitude == null || longitude == null) {
    return null;
  }

  const result = query([longitude, latitude]);

  return result ?? null;
}
